export const QUERY_KEY = 'integration';

export interface CoderPadIntegration {
  api_key: string;
}

export interface CodeSignalIntegration {
  api_key: string;
}

export interface GoogleIntegration {
  admin_user_id: string;
  is_workspace_app: boolean;
}

export interface MicrosoftIntegration {
  active: boolean;
}

export interface MicrosoftGccHighIntegration {
  active: boolean;
}

export interface MicrosoftServiceUserIntegration {
  is_gov: boolean;
  service_account_email: string;
}

export interface MicrosoftServiceUserStoreIntegration {
  client_id: string;
  client_secret: string;
  is_gov: boolean;
}

export interface AshbyIntegration {
  api_key?: string;
  webhook_request_url?: string;
  webhook_secret?: string;
  sync_confidential_jobs?: boolean;
}

export interface GreenhouseOAuthIntegration {
  refresh_token?: string;
  scopes?: string[];
  subdomain?: string;
  webhook_secret?: string;
}

export interface LeverIntegration {
  active: boolean;
}

export interface GemIntegration {
  api_key?: string;
}

export interface SmartRecruitersIntegration {
  active: boolean;
  api_key?: string;
}

export interface KomboIntegration {
  integration_id: string;
}

export interface WorkdayIntegration {
  web_service_url: string;
  ui_url: string;
  domain: string;
  tenant: string;
  password: string;
  username: string;
  interview_raas_url: string;
  job_application_raas_url: string;
  tenant_time_zone: string;
  workers_data_raas_url?: string;
}

export interface ZoomIntegration {
  active: boolean;
}

export interface ZoomCustomIntegration {
  active: boolean;
  account_id: string;
  client_id: string;
  client_secret: string;
  is_gov: boolean;
}

export interface SlackOrgIntegration {
  active: boolean;
  slackTeamId: string;
}

export interface HackerRankIntegration {
  api_key: string;
}

export interface CodilityIntegration {
  api_key: string;
}

export interface BrighthireStoreIntegration {
  api_key: string;
}

export interface MultiDomainIntegration {
  active: boolean;
}
